<h2>Error!</h2>
<p>
  {{ message }}
</p>
